module.exports = __webpack_public_path__ + "img/smiling-face-with-halo.d9702aa4.png";